import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Person',
    field: 'personId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'personId',
      fk: 'personId',
      namespace: 'person',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Grouping',
    field: 'groupingId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'groupingId',
      fk: 'groupingId',
      namespace: 'grouping',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
